import {Composition} from '@common/types/documents/composition.types';

export interface CompositionSheetState {
  composition: Composition | null;
  isLoading: boolean;
}

export type CompositionSections = (typeof CompositionSections)[keyof typeof CompositionSections];
export const CompositionSections = {
  Breadcrumb: 'breadcrumb',
  Energies: 'energies',
  Information: 'information'
} as const;

export interface CompositionSheetActions {
  fetchData: (uuid: string) => Promise<void>;
  setComposition: (data: Composition) => void;
}
